import {
  BackofficeSignInMethod,
  type BackofficeUserInput,
  UserType,
} from '@backoffice-frontend/graphql'

export type BackofficeUserFormValues = {
  user: BackofficeUserInput
  notes: string
  signInMethod: BackofficeSignInMethod
  organizationId: string
  email: string
}

export const defaultValues: BackofficeUserFormValues = {
  user: {
    operatorTenants: [],
    customerTenants: [],
    ridepoolingServiceTenants: [],
    fleets: [],
    allFleets: false,
    systemUser: false,
    groupsApprover: [],
    timedGroups: [],
    timedServiceAreas: [],
    firstName: '',
    lastName: '',
    userType: UserType.Standard,
    backofficeEnabled: false,
    adminPanelEnabled: false,
  },
  signInMethod: BackofficeSignInMethod.ExternalSso,
  notes: '',
  organizationId: '',
  email: '',
}
